import {createUseStyles} from 'react-jss';

const useStyles = createUseStyles({
  icon: {
    fill: '#000',
  },
  path: {
    transform: 'translate(0.5)',
  },
});

export default function PlusIcon(props) {
  const classes = useStyles(props);
  
  return (
    <svg data-test="PlusIcon" className={classes.icon} viewBox="0 0 24 24">
      <path className={classes.path} d="M11 11L11 6 13 6 13 11 18 11 18 13 13 13 13 18 11 18 11 13 6 13 6 11z" />
    </svg>
  );
}
